<template>
  <section class="px-5 py-20 mx-auto max-w-7xl reveal active">
    <div class="flex items-end justify-between mb-10">
      <h2 class="text-2xl font-bold text-gray-900">最新消息</h2>
      <router-link
        to="/news"
        class="text-sm font-medium border-b border-black pb-0.5 hover:text-gray-600 hover:border-gray-600 transition-colors"
        >閱讀更多</router-link
      >
    </div>

    <div class="grid grid-cols-1 gap-8 md:grid-cols-3">
      <router-link
        v-for="(item, item_index) in page_news_data"
        :key="`news_${item_index}`"
        :to="`/news/${item.NewsID}`"
        class="cursor-pointer group"
      >
        <div
          class="relative w-full mb-4 overflow-hidden bg-gray-100 aspect-video rounded-xl"
        >
          <img
            :src="$ImageUrl(item.Image)"
            :alt="item.Title"
            class="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        <div class="mb-2 text-xs font-medium text-gray-500">
          {{ item.Date }}
        </div>
        <h4
          class="font-bold leading-snug text-gray-900 group-hover:underline decoration-1 underline-offset-4"
        >
          {{ item.Title }}
        </h4>
      </router-link>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { getNewsListData } from "@/common/data_convert";
export default {
  name: "NewsListSection",
  methods: {
    GetContent(val) {
      var msg = val.replace(/<\/?[^>]*>/g, ""); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      msg = msg.replace(/&npsp;/gi, ""); //去掉npsp

      return msg.slice(0, 100) + "...";
    },
  },
  computed: {
    ...mapState(["news_data", "news_category_data"]),
    page_news_data() {
      if (this.news_data == null) {
        return [];
      }
      return getNewsListData(this.news_data.List);
    },
  },
};
</script>
